import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CookieSettings from './CookieSettings';
import { initGA, handleConsentChange } from '../utils/analytics';

const Footer: React.FC = () => {
    const [showCookieSettings, setShowCookieSettings] = useState(false);

    const handleConsentChangeWrapper = (preferences: {
        necessary: boolean;
        analytics: boolean;
        marketing: boolean;
    }) => {
        // Call the analytics handler to manage cookies
        handleConsentChange(preferences);
        // Re-initialize GA when consent changes (for cases where consent is granted)
        initGA();
    };

    return (
        <>
            <CookieSettings
                isOpen={showCookieSettings}
                onClose={() => setShowCookieSettings(false)}
                onConsentChange={handleConsentChangeWrapper}
            />
            <footer className="text-white" style={{ backgroundColor: '#282f3b' }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                        {/* Company Info */}
                        <div className="col-span-1 md:col-span-2">
                            <div className="flex items-center space-x-2 mb-4">
                                <span className="text-xl font-bold">OpenLEIs</span>
                            </div>
                            <p className="text-gray-300 mb-4">
                                A comprehensive search platform for Legal Entity Identifiers (LEIs)
                                from around the world. Access and explore global corporate identity
                                data.
                            </p>
                        </div>

                        {/* Information Links */}
                        <div>
                            <h4 className="text-md font-semibold mb-4">Information</h4>
                            <ul className="space-y-2">
                                <li>
                                    <Link
                                        to="/the-lei-system"
                                        className="text-gray-300 hover:text-white transition-colors"
                                    >
                                        The LEI System
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/about-openleis"
                                        className="text-gray-300 hover:text-white transition-colors"
                                    >
                                        About OpenLEIs
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        {/* Resources */}
                        <div>
                            <h4 className="text-md font-semibold mb-4">Resources</h4>
                            <ul className="space-y-2">
                                <li>
                                    <a
                                        href="https://www.gleif.org/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-gray-300 hover:text-white transition-colors"
                                    >
                                        GLEIF
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://www.gleif.org/en/lei-data/lei-code-lists/iso-17442-lei-code-list"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-gray-300 hover:text-white transition-colors"
                                    >
                                        LEI Code List
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Bottom Bar */}
                    <div className="border-t border-gray-700 mt-8 pt-8">
                        <div className="flex flex-col md:flex-row justify-between items-center">
                            <p className="text-gray-400 text-sm">
                                © 2025 OpenCorporates Limited. All rights reserved.
                            </p>
                            <div className="flex flex-wrap gap-4 mt-4 md:mt-0">
                                <Link
                                    to="/privacy-policy"
                                    className="text-gray-400 hover:text-white transition-colors text-sm"
                                >
                                    Privacy Policy
                                </Link>
                                <button
                                    onClick={() => setShowCookieSettings(true)}
                                    className="text-gray-400 hover:text-white transition-colors text-sm underline"
                                >
                                    Cookie Settings
                                </button>
                                {/* <a
                                href="#"
                                className="text-gray-400 hover:text-white transition-colors text-sm"
                            >
                                Terms of Service
                            </a> */}
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;
